module.exports = __webpack_public_path__ + "img/team-group.1466aee0.svg";